import {
  BackArrowButton,
  CancelButton,
  CloseButton,
  FinishButton,
} from "../../../fixedassetelements/button/Button";

import commonstyles from "../Forms.module.css";
import styles from "./PayableUploadedfile.module.css";

import addIcon from "../../../assets/icons/addEcl.svg";
import removeIcon from "../../../assets/icons/removeLoansIcons.svg";
import refreshIcon from "../../../assets/icons/repeatIcon.svg";


function PayableUploadedFile({
  onBack,
  onClose,
  onStartMapping,
  uploadedFiles = [],
  onRemove,
  onAdd,
  onFinish,
}) {
  const files = uploadedFiles ?? [];

  return (
    <div className={commonstyles.backdrop}>
      <div className={`${commonstyles.container} ${styles.smallContainer}`}>
        <div className={`${commonstyles.header} ${commonstyles.headerLarge}`}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>
              Payable Register – Uploaded Files
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.upperText}>
          <h5 className={styles.filesUpload}>{files.length} files uploaded</h5>

          <button className={styles.addButton} onClick={onAdd}>
            <img src={addIcon} alt="add icon" />
            Add Files
          </button>
        </div>

        <div className={styles.fileList}>
          {files.map((file, index) => (
            <div className={styles.fileRow} key={index}>
              <div className={styles.leftSide}>
                <span className={styles.fileName}>{file.name}</span>

                <button
                  className={styles.removeBtn}
                  onClick={() => onRemove?.(index)}
                >
                  <img src={removeIcon} alt="remove" />
                </button>
              </div>

              <div className={styles.mappingRight}>
                {file.isMapped ? (
                  <span className={styles.mapped}>
                    Mapped <img src={refreshIcon} alt="refresh" />
                  </span>
                ) : (
                  <button
                    className={styles.startMapping}
                    onClick={onStartMapping}
                  >
                    Start Mapping
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <CancelButton onClick={onClose} />
          <FinishButton onClick={onFinish} />
        </div>
      </div>
    </div>
  );
}

export default PayableUploadedFile;
